@for (video of allVideoSources; track i; let i = $index) {
  <app-video-background
    class="survey-video"
    [class.active]="currentVideo === video"
    [class.next]="i > 0 && currentVideo !== allVideoSources[i]"
    [source]="video"
    [showLogo]="true"
    [showAnonymous]="true"
  ></app-video-background>
}

<div class="content" [class.hide-content]="hideContent">
  <app-pill
    class="pill"
    [class.expanded]="pillExpanded"
  >
    <app-feature-pill-menu
      #pillMenu
      class="pill-menu"
      (expandedChange)="pillExpanded = $event"
      (menuItemChange)="onMenuItemChange($event)"
    ></app-feature-pill-menu>
  </app-pill>

  <div class="title-container">
    <div class="title" [class.long-translation]="decreaseFontSize">{{headline | translate}}</div>
    <div class="why">
      @if (selectedMenuItemId === -1) {
        <div class="read-why" (click)="navigateToExplain()">{{ 'WebApp.v1.AvailableSurveys.Read.Why' | translate }}</div>
        <span class="white-slash">/</span>
        <div class="play-why" (click)="openHowdyVideo()"><i class="fa-solid fa-play"></i></div>
      }
    </div>

    @if (availableIn.textKey !== '') {
      @if (selectedMenuItemId === who5MenuItemId) {
        <app-button
          class="button"
          [label]="'WebApp.v1.Shared.Buttons.SeeStats' | translate"
          iconLeft="fa-solid fa-chart-simple"
          [fontSize]="32"
          [showOutlineOnHover]="true"
          backgroundColor="#2DADC8"
          routerLink="/stats"
        ></app-button>
      }

      <div
        class="available-in"
        [class.stats]="selectedMenuItemId === who5MenuItemId"
        [class.button]="selectedMenuItemId !== who5MenuItemId"
      >
        <div class="available-in-text">{{availableIn.textKey | translate}}</div>
        <div class="available-in-date-time">
          @if (availableIn.params) {
            {{availableIn.params.count}} {{availableIn.valueKey | translate}}
          } @else {
            {{availableIn.valueKey}}
          }
        </div>
      </div>
    } @else {
      <app-button
        class="button"
        [label]="'WebApp.v1.Shared.Buttons.Start' | translate"
        [iconLeft]="buttonIcon"
        [fontSize]="32"
        [showOutlineOnHover]="true"
        (click)="navigateToSurvey()"
      ></app-button>
    }
  </div>
</div>

@if (showHowdyVideo || fadeOut) {
  <div class="video-container howdy-video" [class.fade-out]="fadeOut" [class.fade-in]="fadeIn">
    <i class="fa-solid fa-xmark close-button" (click)="closeHowdyVideo()"></i>
    <video class="video" controls autoplay>
      <source [src]="s3BaseUrl + 'assets/videos/Howdy Wellbeing Intro ' + language + videoFormat" type="video/mp4">
    </video>
  </div>
}
